import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgListItemLight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 41,
	viewBox: "0 0 22 41",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.5 8C9.17478 9.53049 9.99798 10.554 10.8379 12.5943C10.903 12.7526 11.1254 12.7644 11.2066 12.6137C13.9645 7.48937 16.1186 4.86343 21 1",
			stroke: "#6C6DCE",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5 1H15C15.6986 1 16.3554 1.1791 16.927 1.4939C17.1036 1.59117 17.3268 1.54386 17.4739 1.4059C17.6876 1.20536 17.7518 0.814394 17.498 0.667755C16.763 0.243045 15.9099 0 15 0H5C2.23858 0 0 2.23858 0 5V14C0 16.7614 2.23858 19 5 19H15C17.7614 19 20 16.7614 20 14V5C20 4.71964 19.5334 4.6227 19.2959 4.77167C19.227 4.81489 19.1543 4.85267 19.0785 4.88439C19.0316 4.90398 19 4.94925 19 5V14C19 16.2091 17.2091 18 15 18H5C2.79086 18 1 16.2091 1 14V5C1 2.79086 2.79086 1 5 1Z",
			fill: "currentColor",
			fillOpacity: .08
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.5 30C9.17478 31.5305 9.99798 32.554 10.8379 34.5943C10.903 34.7526 11.1254 34.7644 11.2066 34.6137C13.9645 29.4894 16.1186 26.8634 21 23",
			stroke: "currentColor",
			strokeOpacity: .12,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5 23H15C15.6986 23 16.3554 23.1791 16.927 23.4939C17.1036 23.5912 17.3268 23.5439 17.4739 23.4059C17.6876 23.2054 17.7518 22.8144 17.498 22.6678C16.763 22.243 15.9099 22 15 22H5C2.23858 22 0 24.2386 0 27V36C0 38.7614 2.23858 41 5 41H15C17.7614 41 20 38.7614 20 36V27C20 26.7196 19.5334 26.6227 19.2959 26.7717C19.227 26.8149 19.1543 26.8527 19.0785 26.8844C19.0316 26.904 19 26.9492 19 27V36C19 38.2091 17.2091 40 15 40H5C2.79086 40 1 38.2091 1 36V27C1 24.7909 2.79086 23 5 23Z",
			fill: "currentColor",
			fillOpacity: .08
		})
	]
});
export default SvgListItemLight;
